import axios from 'axios';
import { ServerPath } from '../Constant'; // Update this import path to match your project
 
// ============================================
// 🔧 ENVIRONMENT CONFIGURATION
// Uncomment ONLY ONE environment at a time
// ============================================
 
// qa-dev
const ENVIRONMENT = 'qa-dev';
 
// preprod
// const ENVIRONMENT = 'preprod';
 
// prod
// const ENVIRONMENT = 'prod';
 
/**
* Uploads a file to R2 storage via backend API
* Same signature as before - NO changes needed in components!
*
* @param {File} file - Browser File object
* @param {string} filename - Base filename without extension
* @param {string} container - Primary folder (e.g., 'learning', 'deity')
* @param {string} subcontainer - Secondary folder (e.g., 'media', 'images')
* @returns {Promise<string>} - Public URL of the uploaded file
*/
export async function uploadImage(file, filename, container, subcontainer) {
  if (!file) {
    console.warn('uploadImage called with no file.');
    return '';
  }
 
  try {
    // Convert File to base64
    const base64String = await fileToBase64(file);
    // Get file extension from original filename
    const extension = file.name.split('.').pop();
    const fullFileName = `${filename}.${extension}`;
 
    console.log(`[${ENVIRONMENT.toUpperCase()}] Uploading: ${fullFileName} to ${container}/${subcontainer}`);
 
    // Call backend upload API
    let url = `${ServerPath}/upload`;
    const response = await axios.post(url, {
      fileContent: base64String,
      fileName: fullFileName,
      container: container,
      subcontainer: subcontainer,
      environment: ENVIRONMENT
    });
 
    if (!response.data.success) {
      throw new Error(response.data.message || 'Upload failed');
    }
 
    const publicUrl = response.data.url;
    console.log(`[${ENVIRONMENT.toUpperCase()}] Upload successful: ${publicUrl}`);
    return publicUrl;
 
  } catch (error) {
    console.error(`[${ENVIRONMENT.toUpperCase()}] R2 Upload Error:`, error);
    throw new Error(`Failed to upload file to R2: ${error.message}`);
  }
};
 
/**
* Helper: Convert File object to base64 string
*/
function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Remove the data:image/jpeg;base64, prefix
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = error => reject(error);
  });
}
 
export default uploadImage;